module.exports = __webpack_public_path__ + "img/bu_starter_500.9b3f9910.jpg";